import { normalizeCompanyName } from './normalise.js';
/** Curated brand/employer aliases. Never treat substring, fuzzy or shared-word matches as proof of employment. */
const VERIFIED_NAME_ALIASES = [
    ['scuderia ferrari', 'ferrari'],
    ['atlassian williams f1 team', 'williams racing'],
    ['mercedes amg petronas formula one team', 'mercedes amg petronas f1 team'],
];
/** A suggested identity match is for *finding* saved contacts, never automatic mission evidence or outreach approval. */
export function missionCompanyNameMatch(company, target) {
    const a = normalizeCompanyName(company), b = normalizeCompanyName(target);
    if (a && b && a === b)
        return 'exact';
    if (VERIFIED_NAME_ALIASES.some(([left, right]) => (a === left && b === right) || (a === right && b === left)))
        return 'known-alias';
    return 'none';
}
